import React from 'react';
import './RenewalPersonalInfoCard.scss';

const RenewalPersonalInfoCard = ({
    labelThai,
    applicant,
    sponsor,
    expiryDate,
    telephoneNumber,
    address,
    className = "",
    style = null
}) => {
    return (
        <div style={style} className={`${className} renewal-personal-info-card`}>
            <span className='card-header-text'>{labelThai.cardText}</span>
            <div className='pi-row'>
                <label className='label-name'>
                    {labelThai.applicant}
                </label>
                {applicant?.length > 0 ? <span className='card-body-multiline'>{applicant.map((line, index) => <span key={`applicant${index}`}>{line}</span>)}</span> : null}
            </div>
            <div className='pi-row'>
                <label className='label-name'>
                    {labelThai.sponsor}
                </label>
                {sponsor?.length > 0 ? <span className='card-body-multiline'>{sponsor.map((line, index) => <span key={`sponsor${index}`}>{line}</span>)}</span> : null}
            </div>
            <div className='pi-row'>
                <label className='label-name'>
                    {labelThai.expiryDate}
                </label>
                {expiryDate ? <span>{expiryDate}</span> : null}
            </div>
            <div className='pi-row'>
                <label className='label-name'>
                    {labelThai.telephoneNumber}
                </label>
                {telephoneNumber ? <span>{telephoneNumber}</span> : null}
            </div>
            <div className='pi-column'>
                <label className='label-name'>
                    {labelThai.address}
                </label>
                {address?.length > 0 ?
                    <span className='card-body-multiline'>{address.map((line, index) => <span key={`address${index}`}>{line}</span>)}</span>
                    : null}
            </div>
        </div>
    )
}

export default RenewalPersonalInfoCard
